import React, { Component } from "react";

import {
  CButton,
  CInput,
  CInputGroup,
  CInputGroupAppend,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CLink
} from "@coreui/react";
import { toastr } from "react-redux-toastr";

import URL from "../../config/api";
import axios from "../../config/axios";

class ShareModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: null
    };

    this.input = React.createRef();
  }

  componentDidMount() {
    axios.get(`${URL.api}qrcode?url=${this.props.link}`).then(resp => {
      if (resp.data.success) {
        this.setState({ image: resp.data.data });
      }
    });
  }

  copyLink() {
    this.input.current.select();
    this.input.current.setSelectionRange(0, 99999);

    document.execCommand("copy");

    toastr.success("Copiado!", "O link foi copiado com sucesso!");
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        centered
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>Compartilhar</CModalTitle>
        </CModalHeader>
        <CModalBody className="p-3">
          <div className="font-weight-bold mb-2">Link da atividade</div>
          <CInputGroup className="mb-3">
            <CInput
              readOnly
              value={this.props.link}
              innerRef={this.input}
              className="disabled"
            />
            <CInputGroupAppend>
              <CButton color="primary" onClick={() => this.copyLink()}>
                Copiar
              </CButton>
            </CInputGroupAppend>
          </CInputGroup>
          {this.state.image && (
            <>
              <div className="font-weight-bold mb-2">QRCode da atividade</div>
              <div className="d-flex align-items-center justify-content-center flex-column">
                <img src={this.state.image} />
                <CLink href={this.state.image} download="qrcode.png">
                  <i className="fa fa-cloud-download mr-1"></i>Baixar imagem
                </CLink>
              </div>
            </>
          )}
        </CModalBody>
      </CModal>
    );
  }
}

export default ShareModal;
